import { Button } from "@mui/material";
import { WHATSAPP_URL } from "../config/contact";

export function QuoteButton(props) {
  return (
    <Button
      component="a"
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      variant="contained"
      {...props}
    >
      Solicitar orçamento
    </Button>
  );
}
